// extracted by mini-css-extract-plugin
var _1 = "JWBiKEgDYk";
var _2 = "NIPzpjB72o";
var _3 = "MaTZzT0LWC";
var _4 = "fovuJWInTW";
var _5 = "hDt7505ZZ2";
export { _1 as "textCenter", _2 as "textEnd", _3 as "textNoWrap", _4 as "textStart", _5 as "textTruncate" }
